import { render, staticRenderFns } from "./GeneralOffer.vue?vue&type=template&id=65fe2e89&"
import script from "./GeneralOffer.vue?vue&type=script&lang=ts&"
export * from "./GeneralOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports